import React from "react";

export default function CloseButton({text, setStartExperience, startExperience, setVideoSrc}) {

    const handleCloseButtonClick = () => {
        if (startExperience === false) {
            setStartExperience(true);
        }
        if (typeof setVideoSrc === 'function') {
            setVideoSrc(null);
        }
    };

    return (
        <>
            <button onClick={handleCloseButtonClick} className="close-overlay">
                <svg width="43" height="44" viewBox="0 0 43 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path id="Line 34" d="M31.8196 32.6706L10.6064 11.4574" stroke="white" strokeWidth="2"/>
                    <path id="Line 35" d="M31.8201 11.4573L10.6069 32.6705" stroke="white" strokeWidth="2"/>
                </svg>
            </button>
        </>
    )
}